import { useEffect, useState } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

const modeloDatos = {
   almacenID: 0, 
    empresaID: "",
    descripcion: "",
    ubicacionID: 1,
    activo:true,
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date
   
}
let totaltm = 0.00;
let totalm = 0;
let totalp = 0;
let totalc = 0;

const InformesVentas = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [ListadoReporte, SetListadoReporte] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [ListadoDisponible, SetListadoDisponible] = useState([]);
    const [Listado1, SetListado1] = useState([]);

    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))


    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }

    const obtenerDisponible = async () => {
        let response = await fetch(Api + "VentasMantenimiento/ListaDisponible");

        if (response.ok) {
            let data = await response.json()
            SetListadoDisponible(data)

        }
    }
    const obtenerDatos = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaAlmacen");

        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
        }
    }
    const obtenerReportes = async () => {
        let response = await fetch(Api + "Administracion/Reporteria/3");

        if (response.ok) {
            let data = await response.json()
            SetListadoReporte(data)
        
        }
    }

    useEffect(() => {
        obtenerDatos();
        obtenerReportes()
        obtenerDisponible()
        obtenerDatosArt()
    },[])

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

  

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    const obtenerDatosArt = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaArticulos/" + JSON.parse(user).correo);

        if (response.ok) {
            let data = await response.json()
            SetListado1(data)
       
            totalm = data.reduce((x, y) => {
                return x + (y.precioPromedio - y.costoPromedio);
            }, 0);
            totalc = data.reduce((x, y) => {
                return x + (y.costoPromedio);
            }, 0);
            totalp = data.reduce((x, y) => {
                return x + (y.precioPromedio );
            }, 0);

        }
    }


    const CuadreCajaPV = () => {
       window.open("/ImpresionFactura/" + tabla.pedidoID, '_blank');;
    }
    const CuadreCajaNCF = () => {
        window.open("/impresionInventario/1" , '_blank');
    }
    const Reporte = (e) => {
        window.open("/impresionInventario/"+e, '_blank');
    }
   
    const money = (v) => {

        let locale = "es-DO"


        const n = Number.isFinite(+v) ? +v : 0;

        let out = new Intl.NumberFormat(locale, {
            style: "currency",
            currency: "USD",
            currencyDisplay: "symbol", // a veces algunos locales rinden "US$"
        }).format(n);
        // Quita cualquier “US$” o “USD ” que pudiera aparecer
        out = out.replace(/US\$\s?/i,  "$");
        return out.trim();

    };
  //<div class="reporting-container">
             
            //    <button class="report-button inventory" onClick={() => CuadreCajaNCF()}>
            //        <i class="fas fa-boxes"></i>  Lista de Articulos
            //    </button>
              
            //</div>
            //<div class="reporting-container">
            //{ListadoReporte.map(x => (
            //    <button class="report-button inventory" onClick={() => Reporte(x.reporteID)}>
            //        <i class="fas fa-boxes"></i>  {x.nombreBoton}
            //    </button>
                
            //))}
    //</div>  
    return (
        <>
           
            <div>
<h3>Listado de articulos disponible</h3>
            </div>
            <div>
                <table>
                    <thead>
                        <tr>
                            <th style={{ width: 40 }}>#</th>
                            <th>Codigo</th>
                            <th>Descripción</th>
                            <th className="right" style={{ width: 90 }}>Cant.</th>
                          
                            <th className="right" style={{ width: 90 }}>Costo</th>
                            <th className="right" style={{ width: 90 }}>Precio</th>
                            <th className="right" style={{ width: 90}}>Ganancia</th>
                            <th className="right" style={{ width: 90}}>Total Gan.</th>
                        </tr>
                    </thead>
                    <tbody>

                        {Listado1.map((it, idx) => {
                            const qty = Number(ListadoDisponible.filter(x => x.articuloID == it.articuloID && x.almacenID == it.almacenPorDefecto).map(x => x.cantidad) || 0);
                            const price = Number(it.precioPromedio || 0);
                            const disc = Number(it.costoPromedio || 0);
                            var line = 0;
                            line  = price - disc;
                            var lt = 0.00;
                            lt = (line * qty)
                            totaltm = (totaltm + lt) ;
                            
                            return (
                                <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>{it.articuloID}</td>
                                    <td>{it.descripcion}</td>
                                    <td className="right">{qty}</td>
                                    <td className="right">{disc}</td>
                                    <td className="right">{money(price)}</td>
                                    <td className="right">{money(line)}</td>
                                    <td className="right">{money(line * qty)}</td>
                                    
                              
                                </tr>
                            );

                        })}
                        <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>Totales</td>
                            <td>{money(totalc)}</td>
                            <td> {money(totalp)}</td>
                            <td>
                                
                                {money(totalm)}</td>  <td>
                                
                                {money(totaltm)}</td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </>
        )

}
export default InformesVentas;